/* eslint-disable @typescript-eslint/no-unused-vars */
export class UnreachableCodeError extends Error {
  constructor(
    message = 'The code reached a statement it should not be able to',
    _never?: never
  ) {
    super(message);
  }
}
